import React from 'react';
import { connect } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';

import { setActiveAircraft, setAircraftFilters } from 'actions';
import {
  PATHS,
  LRU_TYPES,
  LruTypeIgnoreList,
  SELECT_OPTION_ALL,
} from 'constants';

import { Col, Row } from 'react-bootstrap';
import LeftNav from 'components/default/LeftNav';
import Content from './Content';
import Overview from './Overview';
import Software from './Software';
import Features from './Features';
import Health from './Health';

import styles from './styles.module.css';

const LRUFaults = (props) => {
  const {
    rAircraftMap,
    rAircraftList,
    rAircraftFilters,
    setActiveAircraft,
    setAircraftFilters,
  } = props;

  const navigate = useNavigate();
  const params = useParams();
  const activeMenuItem = params && params.page ? params.page : 'overview';

  const healthMenu = [];
  LRU_TYPES.getSortedEnumerationItems()
    .filter((type) => !LruTypeIgnoreList.includes(type.value))
    .forEach((type) => {
      const { id, value } = type;
      healthMenu.push({
        display: value,
        id: id,
      });
    });
  healthMenu.sort((a, b) => a.display.localeCompare(b.display));

  const NavMap = {
    'Fleet health': [
      {
        display: 'Overview',
        id: 'overview',
      },
      {
        display: 'Features',
        id: 'features',
      },
      {
        display: 'Content',
        id: 'content',
      },
      {
        display: 'Software',
        id: 'software',
      },
    ],
    'LRU health': healthMenu,
  };

  const onFleetFilterChange = (fleet) => {
    const newFilters = { ...rAircraftFilters, aircraft_type: fleet };
    setAircraftFilters(newFilters);
  };

  const renderMenuItem = () => {
    if (activeMenuItem > 0 && activeMenuItem < 23) {
      return renderLruHealthPage();
    }

    switch (activeMenuItem) {
      case 'content':
        return (
          <Content
            aircraftList={rAircraftList}
            onFleetRowClick={onFleetRowClick}
            navigate={navigate}
            fleetFilter={
              rAircraftFilters?.aircraft_type || SELECT_OPTION_ALL.value
            }
            onFleetFilterChange={(fleet) => onFleetFilterChange(fleet)}
          />
        );
      case 'software':
        return (
          <Software
            aircraftList={rAircraftList}
            onFleetRowClick={onFleetRowClick}
            navigate={navigate}
            fleetFilter={
              rAircraftFilters?.aircraft_type || SELECT_OPTION_ALL.value
            }
            onFleetFilterChange={(fleet) => onFleetFilterChange(fleet)}
          />
        );
      case 'features':
        return (
          <Features
            aircraftList={rAircraftList}
            onFleetRowClick={onFleetRowClick}
            navigate={navigate}
            fleetFilter={
              rAircraftFilters?.aircraft_type || SELECT_OPTION_ALL.value
            }
            onFleetFilterChange={(fleet) => onFleetFilterChange(fleet)}
          />
        );
      case 'overview':
      default:
        return (
          <Overview
            aircraftList={rAircraftList}
            onFleetRowClick={onFleetRowClick}
            navigate={navigate}
            fleetFilter={
              rAircraftFilters?.aircraft_type || SELECT_OPTION_ALL.value
            }
            onFleetFilterChange={(fleet) => onFleetFilterChange(fleet)}
          />
        );
    }
  };

  const onFleetRowClick = (id) => {
    const aircraft = rAircraftMap.get(id);
    setActiveAircraft(aircraft);
    navigate(PATHS.ship);
  };

  const onTailClick = (tail) => {
    const aircraft = rAircraftList.find((ac) => ac.tail === tail);
    setActiveAircraft(aircraft);
    navigate(PATHS.ship);
  };

  const renderLruHealthPage = () => {
    return (
      <Health
        lruTypeId={activeMenuItem}
        aircraftList={rAircraftList}
        navigate={navigate}
        onTailClick={onTailClick}
        fleetFilter={rAircraftFilters?.aircraft_type || SELECT_OPTION_ALL.value}
        onFleetFilterChange={(fleet) => onFleetFilterChange(fleet)}
      />
    );
  };

  return (
    <Row className={styles.root} noGutters>
      <Col md="auto" className={styles.leftPanel}>
        <LeftNav
          activeMenuItem={activeMenuItem}
          changeActiveMenu={(id) => navigate(`${PATHS.lrus}/${id}`)}
          navMap={NavMap}
          primaryHeader="LRUs & Faults"
          testIdPrefix="LRUFaults"
        />
      </Col>
      <Col className={styles.container}>{renderMenuItem()}</Col>
    </Row>
  );
};

const state = (state) => {
  return {
    rAircraftMap: state.aircraftMap,
    rAircraftList: state.aircraftList,
    rAircraftFilters: state.aircraftFilters,
  };
};

const actions = {
  setActiveAircraft,
  setAircraftFilters,
};

export default connect(state, actions)(LRUFaults);
